module.exports = __webpack_public_path__ + "img/about-us-img1.3d3c81a3.jpg";